import React, {useContext, useEffect, useRef, useState} from "react";
import {TIPO_ELEMENTO_LISTA} from "../../../../utility/common";
import {TranslateContext} from "../../../../context/TranslateContext";
import {KpiContext} from "../../../../context/KpiContext";
import CampoInputLista from "./CampoInputLista";
import InputKpiView from "./InputKpiView";
import CampoInputTextarea from "./CampoInputTextarea";
import CampoInputTesto from "./CampoInputTesto";

export default function InputKpiController({
                                               tabella,
                                               idxLivello,
                                               idxSottolivello,
                                               idxElemento,
                                               handlerChange,
                                               disabled = false,
                                               modifica = true,
                                               formikRef,
                                               errors,
                                               values
                                           }) {

    const [valore, setValore] = useState();
    const [elemento, setElemento] = useState();

    const {translate} = useContext(TranslateContext);
    const {fieldKpiFocus, setIdFieldKpiFocus} = useContext(KpiContext);

    const fieldRef = useRef(null);

    //Modifica è abilitato se elemento.tipo_anno === 0
    const isModificaEnabled = !elemento?.tipo_anno || elemento?.tipo_anno === 0;

    useEffect(() => {
        let elementoSelezionato = tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento];
        if (!elementoSelezionato.valore) {
            elementoSelezionato.valore = '';
        }
        setValore(elementoSelezionato.valore)
        setElemento(elementoSelezionato);

        formikRef.current.setFieldValue(elementoSelezionato.cella, elementoSelezionato.valore)
    }, [tabella, idxLivello, idxSottolivello, idxElemento]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (elemento?.id_kpi_elemento === fieldKpiFocus) {
                fieldRef.current?.focus();
            }
        }, 200);

        return () => {
            clearTimeout(timer);
        }
    }, [elemento, fieldKpiFocus]);

    function onFocusCampo() {
        setIdFieldKpiFocus(elemento.id_kpi_elemento)
    }

    function onChangeCampo(event) {
        formikRef.current.setFieldValue(elemento.cella, event.target.value);
        setValore(event.target.value);
    }

    function onBlurCampo(event) {
        let elementoSelezionato = tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento];
        if (!elementoSelezionato.valore) {
            elementoSelezionato.valore = '';
        }

        if (elementoSelezionato.valore != valore) {
            elementoSelezionato.valore = valore;
            setTimeout(() => {
                handlerChange(tabella);
            }, 5)
        }
    }

    function onValidate(value) {
        if ((!elemento.tipo_anno || elemento.tipo_anno == '0')
            && (parseInt(elemento.obbligatorio) === 1 && (!value || value === ''))) {
            return translate('Questo campo è obbligatorio');
        }
    }

    function getCampoInput() {
        //Condizione che controlla se 'modifica' è abilitato o meno
        const isEditable = isModificaEnabled && modifica === true;
        
        if (elemento.tipo == TIPO_ELEMENTO_LISTA) {
            return isEditable ?
                <CampoInputLista
                    elemento={elemento}
                    disabled={disabled}
                    fieldRef={fieldRef}
                    valore={valore}
                    onFocusCampo={onFocusCampo}
                    onChangeCampo={onChangeCampo}
                    onBlurCampo={onBlurCampo}
                    onValidate={onValidate}
                />
                :
                <span className={'sost-span-tabella-kpi'}>{valore}</span>
        } else if (elemento.placeholder && elemento.placeholder !== '') {
            return isEditable ?
                <CampoInputTextarea
                    elemento={elemento}
                    valore={valore}
                    disabled={disabled}
                    formikRef={formikRef}
                    modifica={modifica}
                    onFocusCampo={onFocusCampo}
                    onChangeCampo={onChangeCampo}
                    onBlurCampo={onBlurCampo}
                    onValidate={onValidate}
                />
                :
                <span className={'sost-span-tabella-kpi'}>{valore}</span>

        } else {
            return isEditable ?
                <CampoInputTesto
                    tabella={tabella}
                    elemento={elemento}
                    valore={valore}
                    fieldRef={fieldRef}
                    disabled={disabled}
                    modifica={modifica}
                    onFocusCampo={onFocusCampo}
                    onChangeCampo={onChangeCampo}
                    onBlurCampo={onBlurCampo}
                    onValidate={onValidate}
                />
                :
                <span className={'sost-span-tabella-kpi'}>{valore}</span>
        }
    }

    return (
        <InputKpiView
            elemento={elemento}
            getCampoInput={getCampoInput}
        />
    );
}